import { configureStore } from '@reduxjs/toolkit';

import operationsReducer from './OperationsReducer/operationsSlice';
import userReducer from './UserReducer/userSlice';
import errorReducer from './ErrorReducer/errorSlice';
import overallReducer from './PerformanceReducer/Overall/overallSlice';
import { errorMiddleware } from './middleware/errorMiddleware';
import usageMetricsReducer from './UsageMetricsReducer/usageMetricsSlice';
import ecommSalesPerfReducer from './PerformanceReducer/Ecommerce/ecommSalesPerfSlice';
import yardRxReducer from './PerformanceReducer/Ecommerce/yardRxSlice';
import localLiftMaxReducer from './PerformanceReducer/LocalLift/localLiftMaxSlice';
import productSyncReducer from './PerformanceReducer/Ecommerce/productSyncSlice';
import higherGroundStatusReducer from './HeaderReducer/higherGroundStatusSlice';
import keyOperationalMetricsReducer from './PerformanceReducer/Ecommerce/keyOperationalMetricsSlice';
import ecomOrderDetailsReducer from './PerformanceReducer/Ecommerce/ecomOrderDetailsSlice';
import hgReportReducer from './HeaderReducer/hgReportSlice';
import summaryExportReducer from './HeaderReducer/summaryExportSlice';
import scorecardExportReducer from './HeaderReducer/scorecardExportSlice';
import adwDashboardsTokenReducer from './HeaderReducer/adwDashboardsTokenSlice';

// Create the Redux store based on Redux Toolkit
const store = configureStore({
  reducer: {
    operations: operationsReducer,
    user: userReducer,
    error: errorReducer,
    usageMetrics: usageMetricsReducer,
    ecommSalesPerf: ecommSalesPerfReducer,
    yardRx: yardRxReducer,
    keyOperationalMetrics: keyOperationalMetricsReducer,
    overall: overallReducer,
    localLiftMax: localLiftMaxReducer,
    productSync: productSyncReducer,
    ecomOrderDetails: ecomOrderDetailsReducer,
    higherGroundStatus: higherGroundStatusReducer,
    hgReport: hgReportReducer,
    summaryExport: summaryExportReducer,
    scorecardExport: scorecardExportReducer,
    adwDashboardsToken: adwDashboardsTokenReducer,
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(errorMiddleware),
});

// Defines the shape of your entire Redux state
export type RootState = ReturnType<typeof store.getState>;

// Defines the type of your dispatch function
export type AppDispatch = typeof store.dispatch;

// Expose a read-only getState API on window so that child tabs opened via
// window.open() can read the parent's state through window.opener.
// Only getState is exposed — dispatch and subscribe are intentionally omitted.
// writable/configurable: false prevents external scripts from overwriting the property.
// Guard against non-browser environments (e.g. Jest/Node) where window is undefined.
if (typeof window !== 'undefined') {
  Object.defineProperty(window, '__REDUX_STORE__', {
    value: { getState: (): RootState => store.getState() },
    writable: false,
    configurable: false,
  });
}

export default store;
